// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1bxmT","rightAdornment":"Header_rightAdornment__8KMb7"};